export function BootMark() {
	return (
		<div className="flex min-h-screen items-center justify-center bg-white">
			<div className="size-10 animate-spin rounded-full border-4 border-gray-200 border-t-primary-500" />
		</div>
	);
}
